import { render } from "./TaskTable.vue?vue&type=template&id=face3fb6&scoped=true"
import script from "./jsfiles/TaskTableJs.js?vue&type=script&lang=js"
export * from "./jsfiles/TaskTableJs.js?vue&type=script&lang=js"

import "../../public/assets/CSS/saveiconfile.css?vue&type=style&index=0&lang=css"
import "./TaskTable.vue?vue&type=style&index=1&id=face3fb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-face3fb6"]])

export default __exports__